import React, { useEffect, useState } from 'react'
import BannerHome from '../components/BannerHome'
import { useSelector } from 'react-redux'
import Card from '../components/Card'
import HorizontalScollCard from '../components/HorizontalScollCard'
import axios from 'axios'
import useFetch from '../hooks/useFetch'

const Home = () => {
  const trendingData = useSelector(state => state.movieoData.bannerData)
  const { data : nowPlayingData } = useFetch('/movie/now_playing')
  const { data : topRatedData } = useFetch('/movie/top_rated')
  const { data : popularTvShowData } = useFetch('/tv/popular')

  // ✅ Additional categories
  const { data: malayalamMovies } = useFetch('discover/movie?with_original_language=ml&sort_by=popularity.desc')
  const { data: hindiMovies } = useFetch('discover/movie?with_original_language=hi&sort_by=popularity.desc')
  const { data: tamilMovies } = useFetch('discover/movie?with_original_language=ta&sort_by=popularity.desc')
  const { data: koreanTvSeries } = useFetch('discover/tv?with_original_language=ko&sort_by=popularity.desc')
  const { data: animeSeries } = useFetch('discover/tv?with_original_language=ja&with_genres=16&sort_by=popularity.desc')
  const { data: topRatedTvShows } = useFetch('/tv/top_rated')
  const { data: tvSeries } = useFetch('/tv/on_the_air')

  // ✅ Newly added
  const { data: koreanMovies } = useFetch('discover/movie?with_original_language=ko&sort_by=popularity.desc')
  // const { data: worldwideTvSeries } = useFetch('discover/tv?sort_by=popularity.desc')
  // const { data: worldwideMovies } = useFetch('discover/movie?sort_by=popularity.desc') // ✅ NEW

  // ✅ OTT Movies by Platform (Netflix, Prime, Hotstar) — already released only
  const today = new Date().toISOString().split('T')[0]
  const { data: netflixMovies } = useFetch(`discover/movie?with_watch_providers=8&watch_region=IN&sort_by=release_date.desc&release_date.lte=${today}`)
  const { data: primeMovies } = useFetch(`discover/movie?with_watch_providers=119&watch_region=IN&sort_by=release_date.desc&release_date.lte=${today}`)
  const { data: hotstarMovies } = useFetch(`discover/movie?with_watch_providers=122&watch_region=IN&sort_by=release_date.desc&release_date.lte=${today}`)

  return (
    <div>
        <BannerHome/>
        <HorizontalScollCard data={trendingData} heading={"Trending"} trending={true}/>
        <HorizontalScollCard data={nowPlayingData} heading={"Now Playing"} media_type={"movie"}/>
        <HorizontalScollCard data={topRatedData} heading={"Top Rated Movies"} media_type={"movie"}/>
        <HorizontalScollCard data={malayalamMovies} heading={"Malayalam movies"} media_type={"movie"} /> 
        
        {/* ✅ New sections added below */}
        <HorizontalScollCard data={hindiMovies} heading={"Hindi movies"} media_type={"movie"} />
        <HorizontalScollCard data={tamilMovies} heading={"Tamil movies"} media_type={"movie"} />
        <HorizontalScollCard data={koreanMovies} heading={"Korean Movies"} media_type={"movie"} />
        {/* <HorizontalScollCard data={worldwideMovies} heading={"Worldwide Movies"} media_type={"movie"} /> */} {/* ✅ added */}

        {/* ✅ OTT-specific sections */}
        <HorizontalScollCard data={netflixMovies} heading={"Netflix Movies"} media_type={"movie"} />
        <HorizontalScollCard data={primeMovies} heading={"Amazon Prime Movies"} media_type={"movie"} />
        <HorizontalScollCard data={hotstarMovies} heading={"Disney+ Hotstar Movies"} media_type={"movie"} />

        <HorizontalScollCard data={koreanTvSeries} heading={"K-Drama"} media_type={"tv"} />
        <HorizontalScollCard data={animeSeries} heading={"Anime"} media_type={"tv"} />
        <HorizontalScollCard data={topRatedTvShows} heading={"Top Rated TV Series"} media_type={"tv"} />
        <HorizontalScollCard data={popularTvShowData} heading={"Popular TV Show"} media_type={"tv"}/>
        <HorizontalScollCard data={tvSeries} heading={"TV Series"} media_type={"tv"}/>
        {/* <HorizontalScollCard data={worldwideTvSeries} heading={"Worldwide TV Shows"} media_type={"tv"}/> */} {/* ✅ added */}
    </div>
  )
}

export default Home
